import { LimitsKeys, SortBy } from 'types/pagination';
import { SidebarSortingFilters } from 'views/admin/poolsList/components/SortingFilter/types/sortingFilters';

type Props = {
  filters?: SidebarSortingFilters;
  page?: number;
  limit?: number;
	search?: string;
	creator_address?: `0x${string}`;
	networkId: string;
};

export const createQueryParamsForPools = ({
  filters,
  page = 1,
	limit,
	search,
	creator_address,
	networkId,
}: Props): string => {
	
	const params = new URLSearchParams();
	
  params.append('page', String(page));
	
  search && params.append('search', search);
  
  limit && params.append('limit', String(limit));

	if (filters) {
		const { capitalization, onlyFavorites, tvlOrder, volume } = filters;

		onlyFavorites && params.append('onlyFavorite', String(onlyFavorites));

		tvlOrder && params.append('sortBy', `${SortBy.TVL}:${tvlOrder}`);

		creator_address && params.append('filter.creator_address', creator_address);
		

		if (capitalization[1] > 0) params.append('filter.tvl_usd', `${LimitsKeys.LTE}:${capitalization[1]}`);
		if (capitalization[0] > 0) params.append('filter.tvl_usd', `${LimitsKeys.GTE}:${capitalization[0]}`);
		

		if (volume[1] > 0) params.append('filter.volume_24h_usd', `${LimitsKeys.LTE}:${volume[1]}`)
		if (volume[0] > 0) params.append('filter.volume_24h_usd', `${LimitsKeys.GTE}:${volume[0]}`)

		params.append('filter.network_id', networkId);
	}

  return params.toString();
};
